import request from '../utils/request'

// 4200000548202006068646533719
export function findDataByid({ transactionId, viewSize = 10, viewIndex = 1 }){
  return request({
    url: `/trade/findDataByid/${transactionId}?viewIndex=${viewIndex}&viewSize=${viewSize}`,
    method: 'get',
  })
}
